<kendo-grid [data]="view.gridData" [loading]="view.loading"
    [pageable]="count > view.state.take ? { buttonCount: 5, pageSizes: pageSizes } : false" [pageSize]="view.state.take"
    [skip]="view.state.skip" [sortable]="true" [sort]="view.state.sort" [selectable]="{ mode: 'single' }"
    [group]="view.groups" [groupable]="true" [filterable]="true" [resizable]="true" [filter]="view.state.filter"
    [columnMenu]="true" (dataStateChange)="dataStateChange($event)" (groupChange)="groupChange($event)"
    [kendoGridSelectBy]="" class="w-100">
    <kendo-grid-column field="id" [width]="30" title="ID" format="{0:d}"></kendo-grid-column>
    <kendo-grid-column field="group" [width]="10" title="Group"></kendo-grid-column>
    <kendo-grid-column field="name" [width]="30" title="Name"></kendo-grid-column>
    <kendo-grid-column field="createdOn" [width]="30" title="Created On" filter="date" format="{0:g}">
    </kendo-grid-column>
</kendo-grid>